import useFlag, { FLAGS } from '@rover/shared/js/hooks/useFlag';

type UseSimplifiedDesktopFiltersReturn = {
  isActive: boolean;
};

/**
 * Hook to check if the simplified_desktop_search_filters experiment is active.
 * This experiment controls whether to show simplified filters in the desktop search experience.
 */
export const useSimplifiedDesktopFilters = (): UseSimplifiedDesktopFiltersReturn => {
  const isActive = useFlag(FLAGS.ROLLOUT_SIMPLIFIED_DESKTOP_SEARCH_FILTERS);

  return { isActive };
};
